<div class="modelos-container">
  <h2>Assistente de Geração de Documentos</h2>
  <p class="subtitle">Selecione um modelo para gerar o documento pré-preenchido com os dados do concurso.</p>

  <div class="toolbar">
    <a mat-raised-button color="basic" class="btn-manual"
      href="https://www.sg.unicamp.br/gde/procedimentos-para-realizacao/concurso-professor-doutor#Procedimentos"
      target="_blank" rel="noopener"
      aria-label="Manual de Orientações (abre em nova aba)">
      <mat-icon>menu_book</mat-icon> Manual de Orientações
    </a>

    <span class="toolbar-spacer"></span>

    <mat-form-field appearance="outline" class="filtro-field">
      <mat-label>Buscar modelo</mat-label>
      <input matInput [ngModel]="filtro" (ngModelChange)="filtro = $event; filtrar()" placeholder="Ex: ata, recurso, edital...">
      <mat-icon matSuffix *ngIf="!filtro">search</mat-icon>
      <button *ngIf="filtro" matSuffix mat-icon-button (click)="filtro = ''; filtrar()" aria-label="Limpar busca">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="estado-feedback">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Carregando modelos disponíveis...</span>
  </div>

  <!-- Erro -->
  <div *ngIf="!loading && erro" class="estado-feedback estado-erro">
    <mat-icon color="warn">error_outline</mat-icon>
    <span>Não foi possível carregar os modelos.</span>
    <button mat-stroked-button color="primary" (click)="carregar()">Tentar novamente</button>
  </div>

  <!-- Conteúdo -->
  <mat-accordion multi *ngIf="!loading && !erro">
    <mat-expansion-panel *ngFor="let grupo of gruposFiltrados; trackBy: trackByCategoria" [expanded]="filtro.length > 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="grupo-icon">folder_open</mat-icon>
          {{ grupo.categoria }}
          <span class="badge-count">{{ grupo.modelos.length }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="modelo-list" role="list">
        <div *ngFor="let modelo of grupo.modelos; trackBy: trackByTipo"
             class="modelo-row" [class.disabled]="!modelo.disponivel"
             role="listitem" [attr.aria-disabled]="!modelo.disponivel">
          <mat-icon class="modelo-icon" [class.icon-locked]="!modelo.disponivel">
            {{ modelo.disponivel ? 'description' : 'lock' }}
          </mat-icon>
          <div class="modelo-info">
            <span class="modelo-titulo">{{ modelo.titulo }}</span>
            <span class="modelo-separador">—</span>
            <span class="modelo-descricao">{{ modelo.descricao }}</span>
            <ng-container *ngIf="!modelo.disponivel && modelo.motivoBloqueio">
              <span class="modelo-separador">—</span>
              <span class="motivo-bloqueio">
                <mat-icon inline>info_outline</mat-icon> {{ modelo.motivoBloqueio }}
              </span>
            </ng-container>
          </div>
          <button mat-raised-button color="primary"
            [disabled]="!modelo.disponivel"
            [attr.aria-label]="'Criar documento: ' + modelo.titulo"
            (click)="abrir(modelo)">
            <mat-icon>auto_fix_high</mat-icon> Criar
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Empty state: sem resultados de filtro -->
  <p *ngIf="!loading && !erro && gruposFiltrados.length === 0 && filtro" class="sem-resultados">
    Nenhum modelo encontrado para "{{ filtro }}".
  </p>

  <!-- Empty state: lista vazia sem filtro -->
  <p *ngIf="!loading && !erro && gruposFiltrados.length === 0 && !filtro" class="sem-resultados">
    Nenhum modelo disponível para este concurso.
  </p>
</div>
